import { Component, computed, input } from '@angular/core';
import { ClassValue } from 'clsx';
import { bui } from '../utils/bui';

@Component({
  selector: 'sidebar-label',
  exportAs: 'sidebarLabel',
  host: {
    '[class]': 'computedClass()',
  },
  template: `<ng-content />`,
})
export class SidebarLabel {
  // Inputs / Outputs
  readonly userClass = input<ClassValue>('', { alias: 'class' });

  // State
  protected readonly computedClass = computed(() =>
    bui(
      // Base
      'group/sidebar-label',
      'flex-auto',
      'px-0.5',
      'truncate',

      // User classes
      this.userClass(),
    ),
  );
}
